<!--
 * @Author: your name
 * @Date: 2021-02-01 13:23:33
 * @LastEditTime: 2021-03-02 17:35:48
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xy_project\src\views\Home\common\MembershipInfo.vue
-->
<template>
  <div id='membershipInfo'>
    <div class="shipTitle" v-if="roleType==2&&$route.name=='Management'">入会时间：{{$route.query.initiationTime.substr(0,4)}}年</div>
    <div class="shipTitle" v-if="roleType==3&&userInfoData">入会时间：{{userInfoData.initiationTime.substr(0,4)}}年</div>
    <el-table :data="shipTableData" stripe style="width: 100%">
      <el-table-column label="年份" prop="year">
      </el-table-column>
      <el-table-column label="会员等级" prop="memberGrade">
        <template slot-scope="scope">
          <span v-if="scope.row.memberGrade==1">会长</span>
          <span v-else-if="scope.row.memberGrade==2">副会长</span>
          <span v-else-if="scope.row.memberGrade==3">理事会员</span>
          <span v-else-if="scope.row.memberGrade==4">普通会员</span>
          <span v-else-if="scope.row.memberGrade==5">退出协会</span>
        </template>
      </el-table-column>
      <template v-if="roleType==2&&$route.name=='Management'">
        <el-table-column label="会员等级修改原因" prop="remark">
        </el-table-column>
        <el-table-column label="最近一次操作时间" prop="updateTime">
          <template slot-scope="scope">
            <span>{{scope.row.updateTime.substr(0,10)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <span class="linkStyle" @click="editShip(scope.row)" v-if="shipFlag==1">修 改</span> -->
            <span class="linkStyle" @click="editShip(scope.row)">修 改</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-dialog title="修改历史会员等级" :visible.sync="editLevelVisible" width="25%" custom-class="editLevelVisible" @close="closeLevelDialog">
      <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="年份：" prop="year">
          <span>{{editForm.year}}</span>
        </el-form-item>
        <el-form-item label="会员等级：" prop="memberGrade">
          <el-select v-model="editForm.memberGrade" placeholder="请选择会员等级">
            <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="修改说明：" prop="remark">
          <el-input type="textarea" v-model="editForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <span class="button add" type="primary" @click="sureEdit">确 定</span>
        <span class="button" @click="editLevelVisible = false">取 消</span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { findMembershipInformation, updateMembershipInformation } from '@/api/index'
export default {
  props: ['userInfoData'],
  data() {
    return {
      roleType: window.sessionStorage.getItem('roleType'),
      shipTableData: [],
      editLevelVisible: false,
      shipParams: {
        year: "",
        createUserId: ""
      },
      shipFlag: 0,
      levelOptions: [{
        value: 1,
        label: '会长'
      }, {
        value: 2,
        label: '副会长'
      }, {
        value: 3,
        label: '理事会员'
      }, {
        value: 4,
        label: '普通会员'
      }],
      editForm: {
        id: '',
        memberGrade: '',
        remark: "",
        year: ''
      },
      editFormRules: {
        memberGrade: [
          { required: true, message: '请选择会员等级', trigger: 'blur' },
        ],
        remark: [
          { required: true, message: '请填写修改原因', trigger: 'blur' },
        ],
      }
    }
  },
  created() {
    this.getShipInfo()
  },
  methods: {
    async getShipInfo(fatherData) {
      if (this.roleType == 2 && this.$route.name == 'Management') {
        this.shipParams.createUserId = this.$route.query.id
      } else if (this.roleType == 3 && fatherData) {
        this.shipParams.createUserId = fatherData.userId
      }
      this.shipTableData = []
      const { data } = await findMembershipInformation(this.shipParams)
      if (data.code == 0) {
        // this.shipTableData = data.membershipInformationList
        data.membershipInformationList.forEach((item, i) => {
          if(Number(item.year) >= 2020){
            this.shipTableData.push(item) 
          }
        })
      }
    },
    editShip(row) {
      this.editLevelVisible = true
      this.editForm.year = row.year
      this.editForm.id = row.id
    },
    async sureEdit() {
      const { data } = await updateMembershipInformation(this.editForm)
      if (data.code != 0) return
      this.editLevelVisible = false
      this.getShipInfo()

    },
    closeLevelDialog() {
      this.$refs.editForm.resetFields()
    },
  }
}
</script>
<style lang='less' scoped>
#membershipInfo {
  .shipTitle {
    margin: 0 0 25px 0;
    font-weight: 550;
    font-size: 15px;
    color: #444;
  }
  /deep/.editLevelVisible {
    .el-input__inner {
      background: #fff;
    }
    .el-textarea__inner {
      width: 71%;
    }
  }
}
</style>